import React from 'react';
import { graphql } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

const Image = () => (
  <StaticImage src="../../images/depannage-entretien-ok.png" alt="Depannage" placeholder="blurred" layout="fullWidth" />
);

export default Image;
